import { Radio, RadioProps, withStyles } from '@material-ui/core'
import theme from '../../MuiTheme/theme'

export const PrimaryRadio = withStyles({
  root: {
    color: theme.palette.secondary.main,
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },
  checked: {},
})((props: RadioProps) => <Radio color="default" {...props} data-testid="radio" />)
